const authConstants = {
	SET_LOGOUT: 'SET_LOGOUT',
	SET_LOADING: 'SET_LOADING',
	SET_STATIC_ENUMS: 'SET_STATIC_ENUMS',
	SET_USER_LIST: 'SET_USER_LIST',
};

export default authConstants;
